<template>
  <div id="app" :class="`main-${device}`">
    <vue-header :active="active" @changeActive="changeActive" v-if="!headerwhitelist.includes($route.path)"></vue-header>
    <transition name="fade-transform" mode="out-in">
      <router-view  v-if="isRouterAlive" />
    </transition>
    <!-- <vue-top></vue-top> -->
    <vue-footer :active="active" @changeActive="changeActive" v-if="!footerwhitelist.includes($route.path)"></vue-footer>
  </div>
</template>

<script>
  export default {
    name: 'App',
    components: {
      'vue-header': () => import('@/components/v_header.vue'),
      'vue-footer': () => import('@/components/v_footer.vue'),
      'vue-top': () => import('@/components/backTop.vue'),
    },
    provide() {
      return {
        reload: this.reload,
        changeActive:this.changeActive
      };
    },
    data(){
      return{
        isRouterAlive: true,
        active: window.localStorage.getItem('active')||0,
        text:'',
        url:'',
        headerwhitelist:['/login','/register','/forget'],//白名单，用于对头部和尾部的过滤
        footerwhitelist:['/login','/register','/forget','/download','/introduce']//白名单，用于对头部和尾部的过滤
      }
    },
    methods:{
      // 重新渲染页面
      reload() {
        this.isRouterAlive = false;
        this.$nextTick(function() {
          this.isRouterAlive = true;
        });
      },
      // 切换当前导航索引
      changeActive(index){
        this.active=index
      }
    },
     watch: {
      '$route.path': function (newVal, oldVal) {
        switch(newVal){
          case '/index':
            this.active = 0;
            window.localStorage.setItem("active", 0);
            break;
            case '/about':
            this.active = 1;
            window.localStorage.setItem("active", 1);
            break;
            case '/bingo':
            this.active = 2;
            window.localStorage.setItem("active", 2);
            break;
            case '/recharge':
            this.active = 3;
            window.localStorage.setItem("active", 3);
            break;
            case '/recruitment':
            this.active = 4;
            window.localStorage.setItem("active", 4);
            break;
            case '/supervision':
            this.active = 5;
            window.localStorage.setItem("active", 5);
            break;
          }
      }
    }
  }
</script>

<style>
  body,html{
    /* background: #f2f2f2; */
  }
  img{
    display: block;
  }
  #app{
    min-height: 100vh;
    /* overflow-x: hidden; */
  }
  .main-pc1{
    padding-top: 56px;
    background: white;
  }
  .main-mobile1{
    padding-top: 1.3333rem;
    overflow-x: hidden;
    background: #f4f4f4;
  }
  /* 取消浏览器默认样式 */
  * {
    margin: 0;
    padding: 0;
    list-style: none;
    text-decoration: none;
    box-sizing: border-box;
    /* color: #52575A; */
    /* user-select: none; */
    /* color: #666666; */
    word-break: break-all;
		/* font-family: '微软雅黑'; */
  }
  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #a1a3a9;
    border-radius: 7px;
  }
  /* 设置默认pc宽度 */
  .main-pc .container{
      width: 1200px;
      left: 0;
      right: 0;
      margin: auto;
      position: relative;
  }

  /* 设置文本省略号 */
  .one-line {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
    
    .two-line {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    
    .three-line {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
    }
/* 弹性布局 */
  .flex{
    display: flex;
    flex-direction: row;
  }
  
  .flex_c{
    display: flex;
    flex-direction: column;
  }
  .j_a_center{ 
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .j_center{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .j_start{
    justify-content: flex-start;
  }
  
  .j_end{
    justify-content: flex-end;
  }
  
  .j_between{
    justify-content: space-between;
  }
  .j_around{
    justify-content: space-around;
  }
  .j_evenly{
    justify-content: space-evenly;
  }
  .a_center{
    display: flex;
    align-items: center;
  }
  
  .a_end{
    display: flex;
    align-items: flex-end;
  }
  
  .a_start {
    display:flex;
    align-items: flex-start;
  }
  .flex_full {
    flex:1;
  }

 /* 页面进入动画 */
  .fade-transform-leave-active,
  .fade-transform-enter-active {
    transition: all .4s;
  }
  
  .fade-transform-enter {
    opacity: 0;
    /* transform: scale(0.98); */
  }
  
  .fade-transform-leave-to {
    opacity: 0;
    /* transform: scale(1); */
  }
  
  .pswp{
    z-index: 999999999 !important;
  }
  .pointer{ 
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue